import React from "react";

/**
 * KIP Energy — official logotype.
 * Two pre-processed variants (transparent PNG):
 *  - /assets/kip-logo.png       (original: navy text + orange marks, for light backgrounds)
 *  - /assets/kip-logo-light.png (navy → white, orange preserved, for dark backgrounds)
 */
export default function KipLogo({ variant = "dark", className = "", size = "h-24" }) {
  const src =
    variant === "light" ? "/assets/kip-logo-light.png" : "/assets/kip-logo.png";
  return (
    <img
      src={src}
      alt="KIP Energy — Energy & Mobility"
      data-testid="kip-logo"
      className={`${size} w-auto object-contain ${className}`}
    />
  );
}
